import React, { useState, useEffect } from "react";
import Select from "react-select";

export function SearchSelectWithInput(props) {
  const [inputValue, setInputValue] = useState("");

  const options = props?.data?.map((item) => ({
    label: item[props.labelField],
    value: item[props.valueField]
  })) || [];

  const selectStyles = props.customstyles || props.customstyles2 || props.stylegreen;

  useEffect(() => {
    setInputValue(props.value || "");
  }, [props.value]);

  const handleChange = (selectedOption) => {
    const value = selectedOption ? selectedOption.value : "";
    setInputValue(value);
    if (props.onChange) {
      props.onChange(selectedOption);
    }
  };

  const handleInputChange = (value, actionMeta) => {
    if (actionMeta.action === 'input-change') {
      setInputValue(value);
      
      // Validate on input change
      setTimeout(() => {
        const foundOption = options.find(option => option.value === value);
        if (foundOption) {
          if (props.onChange) props.onChange(foundOption);
          if (props.onValidationError) props.onValidationError("");
        } else if (value && value.trim() !== "") {
          // Invalid input - clear welder name and show error
          if (props.onChange) props.onChange(null);
          if (props.onValidationError) {
            props.onValidationError(props.validationMessage || "Entered Welder Code is not valid welder code");
          }
        }
      }, 500);
    }
  };

  const customStyles = {
    ...selectStyles,
    clearIndicator: () => ({ display: 'none' }),
    indicatorSeparator: () => ({ display: 'none' })
  };

  const selectedOption = options.find(option => option.value === inputValue) || null;
  const isRequired = props.mandatory !== undefined ? props.mandatory : (props.required !== false);

  return (
    <Select
      id={props.id}
      name={props.name}
      required={isRequired}
      classNamePrefix="select"
      options={options}
      styles={customStyles}
      value={selectedOption}
      onInputChange={handleInputChange}
      onChange={handleChange}
      isDisabled={props.disabled}
      placeholder={props.placeholder || ""}
      isClearable={false}
      isSearchable={true}
      filterOption={(option, inputValue) => {
        return option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
               option.value.toLowerCase().includes(inputValue.toLowerCase());
      }}
    />
  );
}

export default SearchSelectWithInput;